import axios from '../axiosFlotex'

const resource = 'new_customer_wizard_preview'
export default {
  request(token) {
    // console.log(['axios step', token, step])
    let data = {
      token,
      payload: null
    }

    // Testy ustawień grup serializacji
    // data.emailCardPin = 'step'+step+'@test.pl'
    // data.customerNote = 'notatka step '+step+' a powinna być tylko po zatwierdzeniu kroku 6!'

    return axios.post(`${resource}/${token}/request`, data).then((result) => {
      // console.log(result.data)
      // console.log(['axios step', token, step])
      return result.data
    })
  },

  reply(token, payload) {
    // console.log(['axios step', token, step])
    let data = {
      token,
      payload: payload
    }

    // Testy ustawień grup serializacji
    // data.emailCardPin = 'step'+step+'@test.pl'
    // data.customerNote = 'notatka step '+step+' a powinna być tylko po zatwierdzeniu kroku 6!'

    return axios.post(`${resource}/${token}/reply`, data).then((result) => {
      // console.log(result.data)
      // console.log(['axios step', token, step])
      return result.data
    })
  }
}
